import { useId, useMemo } from 'react';
import { locale, t } from '../i18n/index.ts';
import { todayDay } from '../lib/clock.ts';
import { debtsWithRateChanges } from '../lib/model.ts';
import { usePlanNotice } from '../state/notices.ts';
import { useStore } from '../state/store.tsx';
import { Icon } from './Icon.tsx';

/** Told once (decision 4): planned rate changes now move the forecast, so these debts' payoff dates may have moved. */
export function RateChangesNote({ className = '' }: { className?: string }) {
  const { plan } = useStore();
  const { dismissed, dismiss } = usePlanNotice('rate-changes');
  const id = useId();
  const today = todayDay();
  const debts = useMemo(() => (plan ? debtsWithRateChanges(plan, today) : []), [plan, today]);
  if (dismissed !== false || debts.length === 0) return null;
  const names = new Intl.ListFormat(locale(), { type: 'conjunction' }).format(debts.map((d) => d.label));
  return (
    <section className={`welcome-note rate-note ${className}`} aria-labelledby={id} data-testid="rate-changes-note">
      <span className="welcome-note__icon" aria-hidden="true"><Icon name="alert" size={17} /></span>
      <div className="welcome-note__body">
        <h2 className="welcome-note__title" id={id}>{t('notice.rates.title')}</h2>
        <p className="welcome-note__text">{t('notice.rates.body', { debts: names })}</p>
      </div>
      <button type="button" className="button button--sm button--ghost rate-note__dismiss" onClick={dismiss}>
        {t('notice.rates.dismiss')}
      </button>
    </section>
  );
}
